import { render, staticRenderFns } from "./BillingList.vue?vue&type=template&id=507f0112&scoped=true"
import script from "./BillingList.vue?vue&type=script&lang=js"
export * from "./BillingList.vue?vue&type=script&lang=js"
import style0 from "./BillingList.vue?vue&type=style&index=0&id=507f0112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507f0112",
  null
  
)

export default component.exports